import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import {
  getPurchase,
  deletePurchase,
  ListPurchaseById,
  uploadInvoice,
  postGeneralData,
  UpdatePaymentComplete,
  PurchasesReturn,
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { PurchaseorderForm } from "./form";
import { Deletemodel, DocumentViewerModal } from "../../Common/Functions";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getFormattedCurrentDate2,
  isReadonlyRoute,
  NaviGate,
  onReqCreatePayment,
  shop_id,
} from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";

const Sales_list = () => {
  const navigate = useNavigate();
  const { selectedWarehouse, showLoader, hideLoader, shopItem, UserItem } = useContext(WarehouseContext);
  const [user, setuser] = useState(UserItem)
  const [Purchase, setPurchase] = useState([]);
  const [ListModal, setListModal] = useState(false);
  const [PO_Data, setPO_Data] = useState([]);
  const [selectedPurchase, setSelectedPurchase] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [showdeleteModal, setShowdeleteModal] = useState(false);
  const [showdeleteID, setShowdeleteID] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [Paymentvalue, setPaymentvalue] = useState();
  const [pamentsModel, setpamentsModel] = useState(false);
  const [payAmount, setPayAmount] = useState(0);
  const [remainingCapital, setRemainingCapital] = useState(0);
  const PurchasePerPage = 10;
  const { pathname } = useLocation();
  const readonly = isReadonlyRoute(pathname);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchText, setSearchText] = useState("");
  const [resetDone, setResetDone] = useState(false);

  // --- Purchase Return State ---
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [returnPurchase, setReturnPurchase] = useState(null);
  const [returnItems, setReturnItems] = useState([]);
  const [returnQtys, setReturnQtys] = useState({});
  const [returnReason, setReturnReason] = useState("");
  const [returnRefundType, setReturnRefundType] = useState("payable_reduction"); // "bank" or "payable_reduction"


  useEffect(() => {
    fetchPurchase();
  }, []);

  useEffect(() => {
    if (resetDone) {
      fetchPurchase(1, "");
      setResetDone(false); // reset the flag after fetching
    }
  }, [resetDone]);

  const fetchPurchase = async (page = 1, text = "") => {
    try {
      showLoader();
      const filters = {
        start_date: fromDate,
        end_date: toDate,
      };
      const response = await getPurchase(page, text, 1, shop_id, filters);
      if (response.data && response.data.data) {
        setPurchase(response.data.data);
        setTotalPages(response.data.pagination.total_pages);
        setRemainingCapital(response.data.remain_capital);
        hideLoader();
      }
    } catch (error) {
      console.error("Error fetching Purchase data:", error);
      toast.error("Error fetching Purchase");
      hideLoader();
    }
  };

  const handleFilter = (e) => {
    e.preventDefault();
    if (fromDate && !toDate) {
      toast.error("Please select To date ");
      return;
    }
    if (toDate && !fromDate) {
      toast.error("Please select From Date");
      return;
    }
    fetchPurchase();
  };



  const resetFilter = () => {
    setFromDate("");
    setToDate("");
    setSearchText("");
    setResetDone(true);
  };


  // const fetchPurchase = async (page = 1, text = "") => {
  //   showLoader();
  //   try {
  //     const response = await getPurchase(page, text, 1, shop_id);
  //     if (response.data && response.data.data) {
  //       setPurchase(response.data.data);
  //       setTotalPages(response.data.pagination.total_pages);
  //       setRemainingCapital(response.data.remain_capital);
  //       hideLoader();
  //     }
  //   } catch (error) {
  //     console.error("Error fetching sales data:", error);
  //     toast.error("Error fetching sales");
  //     hideLoader();
  //   }
  // };

  const handleDelete = async () => {
    try {
      await deletePurchase(showdeleteID);
      toast.success("Purchase deleted successfully");
      fetchPurchase();
      setShowdeleteModal(false);
    } catch (error) {
      console.error("Error deleting Purchase :", error);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchPurchase(pageNumber);
  };

  const handleSearch = async (text) => {
    if (text.length > 3 || text.length == 0) {
      setCurrentPage(1);
      fetchPurchase(1, text);
    }
  };

  const [documentModal, setDocumentModal] = useState(false);
  const [DocumentUrl, setDocumentUrl] = useState("");

  const openDocumentView = (viewer) => {
    const Url = `http://193.203.162.101:8002/media/${viewer}`;
    console.log(Url);
    setDocumentUrl(Url);
    setDocumentModal(true);
  };

  const [isOrderModal, setOrderModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [selectedOrderData, setSelectedOrderData] = useState();
  const [selectedOrderItems, setSelectedOrderItems] = useState([]);

  const handleGetPurchaseOrder = async (state) => {
    try {
      showLoader();
      const response = await ListPurchaseById(state.po);
      hideLoader();

      let payments = [];
      if (response.data && response.data.payment) {
        payments = response.data.payment;
      }
      let items = [];
      if (response.data && response.data.data) {
        items = response.data.data;
      }

      setSelectedOrderData(state);
      setSelectedOrder(payments);
      setSelectedOrderItems(items);
      setOrderModal(true);
    } catch (error) {
      hideLoader();
      console.error("Error fetching order details:", error);
      toast.error("Error fetching purchase details");
    }
  };

  const [cashAmount, setCashAmount] = useState("");
  const [cardAmount, setCardAmount] = useState("");
  const dueAmount = parseFloat(Paymentvalue?.remaining || 0);
  const totalPayment =
    parseFloat(cashAmount || 0) + parseFloat(cardAmount || 0);
  const remainingAmount = dueAmount - totalPayment;

  const Handlepaymentmodel = async (item) => {
    console.log("item", item);
    setPayAmount(0);
    setCashAmount(0);
    setCardAmount(0);
    setPaymentvalue(item);
    setpamentsModel(true);
  };

  const handleCashChange1 = (e) => {
    let value = parseFloat(e.target.value || 0);
    if (value + parseFloat(cardAmount || 0) > dueAmount) return;
    setCashAmount(value);
  };

  const handleCardChange1 = (e) => {
    let value = parseFloat(e.target.value || 0);
    if (value + parseFloat(cashAmount || 0) > dueAmount) return;
    setCardAmount(value);
  };

  const handleCashChange = (e) => {
    let value = e.target.value;

    // allow empty (user erased all digits)
    if (value === "") {
      setCashAmount("");
      return;
    }

    // allow only numbers
    if (!/^\d+$/.test(value)) return;

    const numericValue = parseFloat(value);

    // prevent overpayment
    if (numericValue + parseFloat(cardAmount || 0) > dueAmount) return;

    setCashAmount(value);
  };
  const handleCardChange = (e) => {
    let value = e.target.value;

    if (value === "") {
      setCardAmount("");
      return;
    }

    if (!/^\d+$/.test(value)) return;

    const numericValue = parseFloat(value);

    if (numericValue + parseFloat(cashAmount || 0) > dueAmount) return;

    setCardAmount(value);
  };


  const onHandlePayCredit = async (cashAmount, cardAmount) => {
    try {
      showLoader();
      if (!Paymentvalue?.purchase_id) {
        toast.error("Invalid purchase details");
        hideLoader();
        return;
      }

      const cash = parseFloat(cashAmount || 0);
      const card = parseFloat(cardAmount || 0);

      var paydata = {
        orderID: Paymentvalue?.po,
        date: getFormattedCurrentDate2(),
        amount: "0",
        total_amount: Paymentvalue.total,
        cash: cash,
        credit: 0,
        card: card,
        type: 1,
        mop: "0",
        complete: "0",
      };

      if (cashAmount && cardAmount) {
        paydata.cash = cashAmount;
        paydata.card = cardAmount;
        paydata.mop = "1,4";
        paydata.complete = "1";
      } else if (cashAmount) {
        paydata.cash = cashAmount;
        paydata.mop = "1";
        paydata.complete = "1";
      } else if (cardAmount) {
        paydata.card = cardAmount;
        paydata.mop = "4";
        paydata.complete = "1";
      }
      if (remainingAmount > 0) {
        paydata.credit = remainingAmount;
        paydata.mop = paydata.mop + ",2";
        paydata.complete = "0";
      }
      await onReqCreatePayment(paydata);
      try {
        const generalDataPayload = {
          type: "3",
          ref_id: Paymentvalue?.po,
          remarks: "Purchase",
          date: getFormattedCurrentDate2(),
          created_by: user?.user_id,
          shop_id: shopItem?.id || "0",
          amount: parseFloat(cashAmount || 0) + parseFloat(cardAmount || 0),
          is_debit: "1",
        };
        // await postGeneralData(generalDataPayload);

        const generalDataPayload1 = {
          type: "2",
          ref_id: Paymentvalue?.po,
          remarks: "Bank - To purchase",
          date: getFormattedCurrentDate2(),
          created_by: user?.user_id,
          shop_id: shopItem?.id || "0",
          amount: parseFloat(cashAmount || 0) + parseFloat(cardAmount || 0),
          is_debit: "0",
        };
        await postGeneralData(generalDataPayload1);

        if (paydata?.complete == "0") {
          const generalDataPayload = {
            type: "7",
            ref_id: Paymentvalue?.po,
            remarks: "Purchase Credit",
            date: getFormattedCurrentDate2(),
            created_by: user?.user_id,
            shop_id: shopItem?.id || "0",
            amount: remainingAmount,
            is_debit: "0",
          };
          await postGeneralData(generalDataPayload);
        } else {
          const paymentCompleted = {
            type: "7",
            shop_id: shopItem?.id || "0",
            ref_id: Paymentvalue?.po,
          }
          await UpdatePaymentComplete(paymentCompleted);
        }
      } catch (e) {
        console.error("General log failed:", e);
        toast.error("Failed to create general transaction log");
      }
      toast.success("Payment successfully");
      await fetchPurchase(currentPage);
      setpamentsModel(false);
      setPayAmount(0);
      setCashAmount(0);
      setCardAmount(0);
      hideLoader();
    } catch (error) {
      console.error("Error updating payment:", error);
      toast.error("Error processing payment. Please try again.");
      hideLoader();
    }
  };

  // const FileUploadButton = () => {
  const fileInputRef = useRef(null);
  const [po_id, setpo_id] = useState();

  const handleButtonClick = (data) => {
    console.log(data.po);
    setpo_id(data.po);
    fileInputRef.current.click(); // Trigger file input click
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Prepare FormData
    const formData = new FormData();
    formData.append("po_id", po_id); // Adjust the key based on API requirements
    formData.append("file", file); // Adjust the key based on API requirements

    try {
      const res = await uploadInvoice(formData); // Add await here
      toast.success("Invoice uploaded.");
      await fetchPurchase(); // Ensure it waits for fetchPurchase to complete
    } catch (error) {
      console.error("Upload Error:", error);
      // alert("Failed to upload file.");
    }
  };

  // --- Purchase Return Functions ---
  const handleOpenReturn = async (purchase) => {
    try {
      showLoader();
      const response = await ListPurchaseById(purchase.po);
      hideLoader();

      let items = [];
      if (response.data && response.data.data) {
        items = response.data.data;
      }

      setReturnPurchase(purchase);
      setReturnItems(items);
      setReturnQtys({});
      setReturnReason("");
      setReturnRefundType("payable_reduction"); // Default to reducing supplier payable
      setShowReturnModal(true);
    } catch (error) {
      hideLoader();
      console.error("Error fetching purchase details:", error);
      toast.error("Error fetching purchase details for return");
    }
  };

  const handleReturnQtyChange = (itemId, val, maxQty) => {
    let num = parseFloat(val);
    if (isNaN(num) || num < 0) num = 0;
    if (num > maxQty) num = maxQty;

    // Fix floating point precision tail (e.g. 0.3999999999999986 -> 0.4)
    num = Math.round(num * 10) / 10;

    setReturnQtys((prev) => ({
      ...prev,
      [itemId]: num
    }));
  };

  const calcReturnFinancials = () => {
    let totalReturn = 0;
    returnItems.forEach(it => {
      const q = returnQtys[it.id] || 0;
      // Use purchase_price from backend items, fallback to 0
      const price = parseFloat(it.unit_price || it.purchase_price || it.price || 0);
      totalReturn += q * price;
    });

    // Purchase remaining means how much WE owe the supplier (payable)
    const payableBalance = parseFloat(returnPurchase?.remaining || 0);

    let creditAdjust = 0; // Amount of payable to reduce
    let refundAmount = 0; // Amount we need back in Bank
    let newPayable = payableBalance;

    if (totalReturn <= payableBalance) {
      creditAdjust = totalReturn;
      refundAmount = 0;
      newPayable = payableBalance - totalReturn;
    } else {
      creditAdjust = payableBalance;
      refundAmount = totalReturn - payableBalance;
      newPayable = 0;
    }

    return { totalReturn, payableBalance, creditAdjust, refundAmount, newPayable };
  };

  const handleSubmitReturn = async () => {
    const fin = calcReturnFinancials();
    if (fin.totalReturn <= 0) {
      toast.warning("Please select items to return");
      return;
    }

    try {
      showLoader();

      const sales_update = returnItems.map(it => {
        const retQ = returnQtys[it.id] || 0;
        return {
          id: it.id,
          serial_number: "RETURN", // Just a placeholder
          return_qty: retQ
        };
      }).filter(it => it.return_qty > 0);

      const payload = {
        unique_id: `RET-PO-${returnPurchase.po}-${Date.now()}`,
        amount: fin.refundAmount, // Bank refund
        credit_adjustment: fin.creditAdjust, // Payable offset
        po_id: returnPurchase.po,
        po_number: returnPurchase.po,
        refund_type: returnRefundType, // "bank" or "payable_reduction"
        reason: returnReason,
        supplier_id: returnPurchase.supplier_id,
        sales_update: JSON.stringify(sales_update),
        shop_id: shop_id,
        user_id: user?.id,
        serial_number: "[]"
      };

      const res = await PurchasesReturn(payload);
      hideLoader();

      if (res.data?.status === "success" || res.status === 201 || res.status === 200) {
        toast.success("Purchase return processed successfully!");
        setShowReturnModal(false);
        fetchPurchase(); // refresh list
      } else {
        toast.error(res.data?.message || "Failed to process return");
      }
    } catch (error) {
      hideLoader();
      console.error("Error processing return:", error);
      toast.error(error.response?.data?.message || "Error processing return");
    }
  };
  // ---------------------------------

  return (
    <>
      <div className="page-wrappers">
        <div className="page-content">
          <NaviGate />
          <div className="mb-4 d-flex justify-content-between align-items-center bg-white p-3 rounded-2xl border border-slate-100 shadow-sm">
            <div className="text-start">
              <h3 className="mb-1 fw-bold text-slate-800 tracking-tight" style={{ fontSize: "24px" }}>Purchases</h3>
              <p className="text-sm text-slate-500 mb-0 font-medium">Record and manage purchases from suppliers</p>
            </div>
            {!readonly && (
              <div className="d-flex gap-2">
                <button
                  type="button"
                  onClick={() => (window.location.href = "/add_purchase")}
                  className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 font-semibold text-sm"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
                  New Purchase
                </button>
              </div>
            )}
          </div>

          <hr className="mt-1" />

          <div className="card border-0 shadow-sm rounded-2xl">
            <div className="card-body p-4">
              <div className="col-12 mb-3 mb-md-2">
                <div className="container-fluid">
                  <div className="row align-items-end g-2">

                    {/* From Date */}
                    <div className="col-6 col-md-2">
                      <div className="text-start">
                        <label className="form-label mb-1" style={{ fontSize: "14px", color: "#64748b", fontWeight: "500" }}>From Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={fromDate}
                          max={toDate}
                          onChange={(e) => setFromDate(e.target.value)}
                        />
                      </div>
                    </div>

                    {/* To Date */}
                    <div className="col-6 col-md-2">
                      <div className="text-start">
                        <label className="form-label mb-1" style={{ fontSize: "14px", color: "#64748b", fontWeight: "500" }}>To Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={toDate}
                          min={fromDate}
                          onChange={(e) => setToDate(e.target.value)}
                        />
                      </div>
                    </div>

                    {/* Purchase ID Search */}
                    <div className="col-6 col-md-2">
                      <div className="text-start">
                        <label className="form-label mb-1" style={{ fontSize: "14px", color: "#64748b", fontWeight: "500" }}>Purchase ID</label>
                        <input
                          type="text"
                          className="form-control"
                          value={searchText}
                          onChange={(e) => {
                            setSearchText(e.target.value);
                            handleSearch(e.target.value);
                          }}
                          placeholder="Search by ID"
                        />
                      </div>
                    </div>

                    {/* Filter & Reset Buttons */}
                    <div className="col-12 col-md-3 mb-2 mb-md-0 d-flex align-items-end gap-2">
                      <button
                        type="submit"
                        onClick={handleFilter}
                        className="btn btn-primary btn-sm px-3 py-1.5 w-auto"
                        style={{ fontSize: "0.85rem", minWidth: "90px", height: "38px" }}
                      >
                        Filter
                      </button>
                      <button
                        type="button"
                        onClick={resetFilter}
                        className="btn btn-secondary btn-sm px-3 py-1.5 w-auto"
                        style={{ fontSize: "0.85rem", minWidth: "90px", height: "38px" }}
                      >
                        Reset
                      </button>
                    </div>

                    {/* Capital Display Button */}
                    <div className="col-12 col-md-4 mb-2  d-flex flex-column align-items-end gap-1">
                      <div
                        className="btn btn-outline-success btn-sm d-none flex-column align-items-center justify-content-center"
                        style={{ fontSize: "0.8rem", lineHeight: "1.2" }}
                        onClick={() => navigate("/expense")}
                      >
                        <span className="fw-semibold text-decoration-underline">Capital</span>
                        <span>{remainingCapital}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <table
                  className="table table-hover table-align-middle text-center mb-4"
                  style={{ width: "100%", fontFamily: "Poppins" }}
                >
                  <thead className="table-light">
                    <tr>
                      <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Purchase #</th>
                      <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Supplier</th>
                      <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Date</th>
                      <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Total</th>
                      <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Paid</th>
                      <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Status</th>
                      <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Invoice</th>
                      {!readonly && <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Actions</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {Purchase.length > 0 ? (
                      Purchase.map((item, index) => {
                        const total = parseFloat(item.total || 0);
                        const remaining = parseFloat(item.remaining !== undefined ? item.remaining : item.total || 0);
                        const paid = item.purchase_unit == 1 ? total : (total - remaining);
                        return (
                          <tr key={item.purchase_id} className="align-middle border-bottom border-slate-100">
                            <td className="text-sm font-semibold text-slate-700 py-3">{item.po}</td>
                            <td className="text-sm text-slate-600">{item.supplier_name}</td>
                            <td className="text-sm text-slate-600">{item.date}</td>
                            <td className="text-sm font-semibold text-slate-700">{total.toFixed(3)} INR</td>
                            <td className="text-sm font-semibold text-slate-700">{paid.toFixed(3)} INR</td>
                            <td>
                              {(item.purchase_unit == 1 || paid >= total) ? (
                                <span className="badge px-2.5 py-1 text-xs font-bold uppercase rounded-full" style={{ backgroundColor: "#ecfdf5", color: "#10b981" }}>
                                  Paid
                                </span>
                              ) : (
                                <span className="badge px-2.5 py-1 text-xs font-bold uppercase rounded-full" style={{ backgroundColor: "#fff7ed", color: "#f97316" }}>
                                  Pending
                                </span>
                              )}
                            </td>
                            <td>
                              {item.file ? (
                                <button
                                  className="btn btn-link p-0 text-decoration-none d-flex align-items-center gap-1 mx-auto justify-content-center"
                                  onClick={() => openDocumentView(item.file)}
                                >
                                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-blue-600"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" /><polyline points="14 2 14 8 20 8" /></svg>
                                  <span className="text-xs font-semibold text-blue-600">View</span>
                                </button>
                              ) : (
                                <button
                                  className="btn btn-link p-0 text-decoration-none d-flex align-items-center gap-1 mx-auto justify-content-center text-slate-400"
                                  onClick={() => handleButtonClick(item)}
                                >
                                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-slate-400"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>
                                  <span className="text-xs font-medium text-slate-400">Upload</span>
                                </button>
                              )}
                            </td>
                            {!readonly && (
                              <td>
                                <div className="d-flex align-items-center gap-3 justify-content-center">
                                  <button
                                    className="btn btn-link p-0 text-decoration-none d-flex align-items-center gap-1 text-slate-600 hover:text-blue-600"
                                    onClick={() => handleGetPurchaseOrder(item)}
                                  >
                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-slate-500"><circle cx="12" cy="12" r="3" /><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /></svg>
                                    <span className="text-xs font-semibold">View</span>
                                  </button>
                                  <button
                                    className="btn btn-link p-0 text-decoration-none d-flex align-items-center gap-1 text-danger"
                                    onClick={() => handleOpenReturn(item)}
                                  >
                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                                      <polyline points="9 22 9 12 15 12 15 22" />
                                    </svg>
                                    <span className="text-xs font-semibold">Return</span>
                                  </button>
                                </div>
                              </td>
                            )}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center text-slate-400 py-4">
                          No purchases found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
                <div className="pagination mb-1">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    className={`page-link text-normal rounded-1 ${currentPage === 1 ? "disabled" : ""
                      }`}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>

                  {Array.from({ length: totalPages }, (_, index) => (
                    <button
                      key={index + 1}
                      onClick={() => handlePageChange(index + 1)}
                      className={`page-link text-normal rounded-1 ${currentPage === index + 1 ? "active" : ""
                        }`}
                    >
                      {index + 1}
                    </button>
                  ))}

                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    className={`page-link text-normal rounded-1 ${currentPage === totalPages ? "disabled" : ""
                      }`}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {showdeleteModal && (
          <Deletemodel
            setShowModal={setShowdeleteModal}
            handleDelete={handleDelete}
          />
        )}

        {ListModal && (
          <PurchaseorderForm
            selectedPurchase={selectedPurchase}
            PO_Data={PO_Data}
            reloadlist={fetchPurchase}
            onClose={() => setListModal(false)}
          />
        )}
      </div>

      {documentModal && (
        <DocumentViewerModal
          setShowModal={setDocumentModal}
          documentUrl={DocumentUrl}
        />
      )}

      <div
        className="modal fade show"
        style={{ display: showModal ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" style={{ fontFamily: "poppins" }}>
                Update Purchase
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                style={{ fontFamily: "poppins" }}
                onClick={() => setShowModal(false)}
              ></button>
            </div>
            <div className="modal-body" style={{ fontFamily: "poppins" }}>
              <form>
                <button type="submit" className="btn btn-success float-end">
                  Update
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-secondary ml-2 float-end me-1"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade show"
        style={{ display: pamentsModel ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content p-3"
            style={{
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            }}
          >
            {/* Modal Header */}
            <div className="modal-header border-0">
              <h5 className="modal-title fw-bold text-dark font-18">Payment</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setpamentsModel(false)}
              ></button>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              <div className="p-3 bg-light rounded ">
                <p className="mb-2 text-start">
                  Order ID: <span className="fw-bold">{Paymentvalue?.po}</span>
                </p>
                <p className="mb-2 text-start">
                  <span>Supplier Name:</span>
                  <span className="fw-bold">{Paymentvalue?.supplier_name}</span>
                </p>
                <hr />
                <div>
                  <p className="mb-2 d-flex justify-content-between">
                    <span>Amount:</span>
                    <span className="text-primary fw-bold">
                      {Paymentvalue?.total}
                    </span>
                  </p>
                  <p className="mb-2 d-flex justify-content-between">
                    <span>Due Amount:</span>
                    <span className="text-danger fw-bold">
                      {Paymentvalue?.remaining || "00"}
                    </span>
                  </p>
                  <p className="mb-2 d-flex justify-content-between align-items-center">
                    <span>Cash:</span>
                    <input
                      type="number"
                      className="form-control text-end w-25"
                      value={cashAmount}
                      onChange={(e) => handleCashChange(e)}
                    />
                  </p>
                  <p className="mb-2 d-flex justify-content-between align-items-center">
                    <span>Card:</span>
                    <input
                      type="number"
                      className="form-control text-end w-25"
                      value={cardAmount}
                      onChange={(e) => handleCardChange(e)}
                    />
                  </p>
                </div>
                <hr />
                <p className="mb-0 fw-bold fs-5 text-end">
                  Remaining Amount:
                  <span className="text-success fw-bold">
                    {remainingAmount.toFixed(3)}
                  </span>
                </p>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="modal-footer border-0 d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-secondary me-2"
                onClick={() => setpamentsModel(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-success"
                disabled={
                  totalPayment <= 0 ||
                  totalPayment > parseFloat(Paymentvalue?.remaining || 0)
                }
                onClick={() => onHandlePayCredit(cashAmount, cardAmount)}
              >
                Pay Now
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ── PURCHASE RETURN MODAL ─────────────────────────────────── */}
      {showReturnModal && (() => {
        const fin = calcReturnFinancials();
        return (
          <div
            className="modal fade show"
            style={{ display: "block", background: "rgba(0,0,0,0.55)", zIndex: 1060 }}
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
              <div className="modal-content" style={{ borderRadius: "14px", border: "none", boxShadow: "0 20px 60px rgba(0,0,0,0.25)" }}>

                {/* Header */}
                <div className="modal-header" style={{ background: "linear-gradient(135deg, #10b981 0%, #047857 100%)", borderRadius: "14px 14px 0 0" }}>
                  <div>
                    <h5 className="modal-title text-white fw-bold mb-0">
                      🔄 Process Purchase Return
                    </h5>
                    <small className="text-white opacity-75">
                      PO: {returnPurchase?.po} &nbsp;|&nbsp; Supplier: {returnPurchase?.supplier_name}
                    </small>
                  </div>
                  <button type="button" className="btn-close btn-close-white" onClick={() => setShowReturnModal(false)} />
                </div>

                {/* Body */}
                <div className="modal-body p-4">

                  {/* Order Items Table */}
                  <h6 className="fw-bold mb-3 text-dark">Select Items to Return</h6>
                  {returnItems.length === 0 ? (
                    <div className="text-center text-muted py-4">No items found for this purchase.</div>
                  ) : (
                    <div className="table-responsive mb-4">
                      <table className="table table-bordered table-sm align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th>Product</th>
                            <th className="text-center">Purchased Qty</th>
                            <th className="text-center">Remaining Qty</th>
                            <th className="text-center">Unit Price</th>
                            <th className="text-center">Return Qty</th>
                            <th className="text-end">Return Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {returnItems.map((it, idx) => {
                            const purchQty = parseFloat(it.qty || 0);
                            const maxReturnableQty = it.remaining_stock !== undefined ? parseFloat(it.remaining_stock) : purchQty;
                            const retQty = returnQtys[it.id] || 0;
                            const price = parseFloat(it.unit_price || it.purchase_price || it.price || 0);
                            const retAmt = retQty * price;
                            return (
                              <tr key={it.id} className={retQty > 0 ? "table-warning" : ""}>
                                <td>{idx + 1}</td>
                                <td>
                                  <div className="fw-semibold">{it.product_name || it.raw_material_name || it.rawmaterial_name || it.title || "Unknown"}</div>
                                </td>
                                <td className="text-center">{purchQty}</td>
                                <td className="text-center fw-semibold text-primary">{maxReturnableQty.toFixed(1)}</td>
                                <td className="text-center">₹{price.toFixed(2)}</td>
                                <td className="text-center" style={{ width: "130px" }}>
                                  <div className="d-flex align-items-center gap-1 justify-content-center">
                                    <button
                                      className="btn btn-outline-secondary btn-sm px-2 py-0"
                                      onClick={() => {
                                        const prevQty = retQty % 1 !== 0 ? Math.floor(retQty) : retQty - 1;
                                        handleReturnQtyChange(it.id, prevQty.toString(), maxReturnableQty);
                                      }}
                                    >−</button>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm qty-input-no-spin"
                                      value={retQty}
                                      min={0}
                                      max={maxReturnableQty}
                                      onChange={(e) => handleReturnQtyChange(it.id, e.target.value, maxReturnableQty)}
                                    />
                                    <button
                                      className="btn btn-outline-secondary btn-sm px-2 py-0"
                                      onClick={() => handleReturnQtyChange(it.id, (retQty + 1).toString(), maxReturnableQty)}
                                    >+</button>
                                  </div>
                                </td>
                                <td className="text-end fw-semibold">
                                  {retQty > 0 ? `₹${retAmt.toFixed(2)}` : "—"}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {/* Financial Summary */}
                  <div className="card border-0 mb-3" style={{ background: "#f8f9fa" }}>
                    <div className="card-body p-3">
                      <h6 className="fw-bold mb-3" style={{ color: "#047857" }}>Financial Summary</h6>
                      <div className="row g-2">
                        <div className="col-6">
                          <div className="d-flex justify-content-between border-bottom pb-2">
                            <span className="text-muted small">Total Return Value</span>
                            <span className="fw-bold">₹{fin.totalReturn.toFixed(2)}</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="d-flex justify-content-between border-bottom pb-2">
                            <span className="text-muted small">Current Supplier Payable</span>
                            <span className="fw-bold text-danger">₹{parseFloat(returnPurchase?.remaining || 0).toFixed(2)}</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="d-flex justify-content-between border-bottom pb-2">
                            <span className="text-muted small">Payable Adjusted</span>
                            <span className="fw-bold text-warning">−₹{fin.creditAdjust.toFixed(2)}</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="d-flex justify-content-between border-bottom pb-2">
                            <span className="text-muted small">Refund Amount (Receivable)</span>
                            <span className="fw-bold text-success">₹{fin.refundAmount.toFixed(2)}</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="d-flex justify-content-between">
                            <span className="text-muted small">New Payable Balance</span>
                            <span className="fw-bold text-primary">₹{fin.newPayable.toFixed(2)}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Refund Type Toggle */}
                  {fin.refundAmount > 0 && (
                    <div className="mb-3">
                      <label className="fw-semibold mb-2 d-block">How to handle ₹{fin.refundAmount.toFixed(2)} receivable?</label>
                      <div className="d-flex gap-3">
                        <div
                          className={`flex-fill p-3 rounded border-2 cursor-pointer ${returnRefundType === "bank" ? "border border-success bg-success bg-opacity-10" : "border"}`}
                          style={{ cursor: "pointer" }}
                          onClick={() => setReturnRefundType("bank")}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <input type="radio" checked={returnRefundType === "bank"} onChange={() => setReturnRefundType("bank")} />
                            <div>
                              <div className="fw-bold small">Receive to Bank</div>
                              <div className="text-muted" style={{ fontSize: "11px" }}>Supplier pays cash back now</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`flex-fill p-3 rounded border-2 cursor-pointer ${returnRefundType === "payable_reduction" ? "border border-primary bg-primary bg-opacity-10" : "border"}`}
                          style={{ cursor: "pointer" }}
                          onClick={() => setReturnRefundType("payable_reduction")}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <input type="radio" checked={returnRefundType === "payable_reduction"} onChange={() => setReturnRefundType("payable_reduction")} />
                            <div>
                              <div className="fw-bold small">Keep as Supplier Receivable</div>
                              <div className="text-muted" style={{ fontSize: "11px" }}>Use against future purchases</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Return Reason */}
                  <div className="mb-2">
                    <label className="fw-semibold mb-1 small">Return Reason <span className="text-muted">(optional)</span></label>
                    <textarea
                      className="form-control form-control-sm"
                      rows={2}
                      placeholder="e.g. Damaged product, wrong specification..."
                      value={returnReason}
                      onChange={(e) => setReturnReason(e.target.value)}
                    />
                  </div>

                </div>

                {/* Footer */}
                <div className="modal-footer border-0 pt-0">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowReturnModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-success fw-bold"
                    onClick={handleSubmitReturn}
                    disabled={fin.totalReturn === 0}
                  >
                    Confirm Return — ₹{fin.totalReturn.toFixed(2)}
                  </button>
                </div>

              </div>
            </div>
          </div>
        );
      })()}
      {/* ─────────────────────────────────────────────────────────── */}

      <OrderDetailsModal
        orders={selectedOrder}
        isOpen={isOrderModal}
        selectedOrder={selectedOrderData}
        items={selectedOrderItems}
        onClose={() => setOrderModal(false)}
        onRecordPayment={Handlepaymentmodel}
      />
    </>
  );
};

const OrderDetailsModal = ({ orders, isOpen, onClose, selectedOrder, items, onRecordPayment }) => {
  const navigate = useNavigate();
  if (!isOpen || !selectedOrder) return null;

  const total = parseFloat(selectedOrder.total || 0);
  const remaining = parseFloat(selectedOrder.remaining !== undefined ? selectedOrder.remaining : selectedOrder.total || 0);
  const paid = selectedOrder.purchase_unit == 1 ? total : (total - remaining);
  const status = remaining <= 0 ? "paid" : "unpaid";

  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{ zIndex: 1050, overflowY: "auto" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content border-0 shadow-2xl rounded-2xl p-4 bg-white">

            {/* Modal Header */}
            <div className="modal-header border-0 pb-0 d-flex justify-content-between align-items-start">
              <div>
                <h4 className="modal-title fw-bold text-slate-800 tracking-tight" style={{ fontFamily: "Poppins" }}>
                  Purchase Details - {selectedOrder.po}
                </h4>
                <p className="text-xs text-slate-400 mt-1 font-medium text-start" style={{ fontFamily: "Poppins" }}>
                  View purchase information and payment history
                </p>
              </div>
              <button
                type="button"
                className="btn-close shadow-none"
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>

            {/* Modal Body */}
            <div className="modal-body py-4" style={{ fontFamily: "Poppins" }}>

              {/* Purchase Details Grid */}
              <div className="row g-4 mb-4 text-start">
                <div className="col-6 col-md-3">
                  <span className="text-xs font-bold text-slate-400 uppercase tracking-wider block mb-1">Supplier</span>
                  <span className="text-sm font-semibold text-slate-700">{selectedOrder.supplier_name}</span>
                </div>
                <div className="col-6 col-md-3">
                  <span className="text-xs font-bold text-slate-400 uppercase tracking-wider block mb-1">Date</span>
                  <span className="text-sm font-semibold text-slate-700">{selectedOrder.date}</span>
                </div>
                <div className="col-6 col-md-3">
                  <span className="text-xs font-bold text-slate-400 uppercase tracking-wider block mb-1">PO Number</span>
                  <span className="text-sm font-semibold text-slate-700">{selectedOrder.po_number || "-"}</span>
                </div>
                <div className="col-6 col-md-3">
                  <span className="text-xs font-bold text-slate-400 uppercase tracking-wider block mb-1">Status</span>
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold uppercase tracking-wide ${status === "paid" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
                    }`}>
                    {status}
                  </span>
                </div>
              </div>

              {/* Payment Summary Cards */}
              <div className="row g-3 mb-4 text-center align-items-stretch">
                <div className="col-6 col-md-3">
                  <div className="p-3 bg-slate-50 border border-slate-100 rounded-xl d-flex flex-column justify-content-center h-100 shadow-sm">
                    <span className="text-xs font-medium text-slate-400 block mb-1">Total Amount</span>
                    <strong className="text-base text-slate-700 font-bold">{total.toFixed(3)} INR</strong>
                  </div>
                </div>
                <div className="col-6 col-md-3">
                  <div className="p-3 bg-emerald-50/50 border border-emerald-100 rounded-xl d-flex flex-column justify-content-center h-100 shadow-sm">
                    <span className="text-xs font-medium text-slate-400 block mb-1">Total Paid</span>
                    <strong className="text-base text-emerald-600 font-bold">{paid.toFixed(3)} INR</strong>
                  </div>
                </div>
                <div className="col-6 col-md-3">
                  <div className="p-3 bg-purple-50/50 border border-purple-100 rounded-xl d-flex flex-column justify-content-center h-100 shadow-sm">
                    <span className="text-xs font-medium text-slate-400 block mb-1">Credit Tallied</span>
                    <strong className="text-base text-purple-600 font-bold">0.000 INR</strong>
                  </div>
                </div>
                <div className="col-6 col-md-3">
                  <div className="p-3 bg-orange-50/50 border border-orange-100 rounded-xl d-flex flex-column justify-content-center h-100 shadow-sm">
                    <span className="text-xs font-medium text-slate-400 block mb-1">Outstanding</span>
                    <strong className="text-base text-orange-600 font-bold">{remaining.toFixed(3)} INR</strong>
                  </div>
                </div>
              </div>

              {/* Actions Button */}
              {status !== "paid" && (
                <div className="d-flex justify-content-end mb-4">
                  <button
                    className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2.5 rounded-xl shadow-lg shadow-blue-100 font-semibold"
                    style={{ backgroundColor: "#004785", borderColor: "#004785" }}
                    onClick={() => {
                      onClose();
                      onRecordPayment(selectedOrder);
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "bold" }}>$</span>
                    Record Payment
                  </button>
                </div>
              )}

              {/* Items section */}
              <div className="text-start mb-4">
                <h5 className="fw-bold text-slate-800 mb-3 tracking-tight">Raw Materials Purchased</h5>
                {items && items.length > 0 ? (
                  <div className="table-responsive border border-slate-100 rounded-xl shadow-sm">
                    <table className="table table-align-middle text-center mb-0">
                      <thead className="table-light border-0">
                        <tr>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">#</th>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider text-start">Item Name</th>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Quantity</th>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Price (INR)</th>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Total (INR)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {items.map((item, index) => (
                          <tr key={index} className="border-top border-slate-50">
                            <td className="py-2.5 text-sm font-semibold text-slate-500">{index + 1}</td>
                            <td className="py-2.5 text-sm text-slate-600 text-start">{item.product_name || item.raw_material_name || item.rawmaterial_name || item.title || "Unknown"}</td>
                            <td className="py-2.5 text-sm text-slate-600">{item.qty} {item.unit || item.p_weight || ""}</td>
                            <td className="py-2.5 text-sm text-slate-600">{parseFloat(item.unit_price || item.purchase_price || item.price || item.rawmaterial_price || 0).toFixed(3)}</td>
                            <td className="py-2.5 text-sm font-bold text-slate-700">
                              {(parseFloat(item.qty || 0) * parseFloat(item.unit_price || item.purchase_price || item.price || item.rawmaterial_price || 0)).toFixed(3)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="p-4 text-center bg-slate-50 rounded-xl border border-slate-100 text-sm text-slate-500">
                    No items found for this purchase
                  </div>
                )}
              </div>

              {/* Payment History section */}
              <div className="text-start">
                <h5 className="fw-bold text-slate-800 mb-3 tracking-tight">Payment History</h5>

                {orders && orders.filter(item => item.mop != "2").length > 0 ? (
                  <div className="table-responsive border border-slate-100 rounded-xl shadow-sm">
                    <table className="table table-align-middle text-center mb-0">
                      <thead className="table-light border-0">
                        <tr>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">#</th>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Date</th>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">MOP</th>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Amount (INR)</th>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {orders
                          .filter((item) => item.mop != "2")
                          .map((item, index) => (
                            <tr key={index} className="border-top border-slate-50">
                              <td className="py-2.5 text-sm font-semibold text-slate-500">{index + 1}</td>
                              <td className="py-2.5 text-sm text-slate-600">{item.date}</td>
                              <td className="py-2.5 text-sm text-slate-600">
                                {item.mop == "1" ? "Cash" : item.mop == "4" ? "Card" : "Multiple"}
                              </td>
                              <td className="py-2.5 text-sm font-bold text-slate-700">
                                {parseFloat(item.amount).toFixed(3)} INR
                              </td>
                              <td className="py-2.5">
                                <button
                                  className="btn btn-link p-0 text-decoration-none d-flex align-items-center gap-1 mx-auto justify-content-center text-slate-500 hover:text-blue-600"
                                  onClick={() => {
                                    onClose();
                                    navigate("/purchase_pdf", {
                                      state: {
                                        ...selectedOrder,
                                        mop: item.mop == "1" ? "Cash" : item.mop == "4" ? "Card" : "Multiple",
                                        date: item.date,
                                        payment: orders.filter((item) => item.mop != "2").slice(0, index + 1),
                                      },
                                    });
                                  }}
                                >
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3" /><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /></svg>
                                  <span className="text-xs font-semibold">View</span>
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="py-5 bg-slate-50 border border-dashed border-slate-200 rounded-2xl text-center">
                    <div className="w-10 h-10 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-2 text-slate-400">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="16" rx="2" /><line x1="16" y1="2" x2="16" y2="4" /><line x1="8" y1="2" x2="8" y2="4" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
                    </div>
                    <p className="text-xs font-semibold text-slate-400 mb-0">No payments recorded yet</p>
                  </div>
                )}
              </div>

            </div>

            {/* Modal Footer */}
            <div className="modal-footer border-0 pt-0 d-flex justify-content-end gap-2">
              <button
                type="button"
                className="btn btn-outline-secondary border-slate-200 text-slate-600 px-4 py-2 rounded-xl font-semibold shadow-sm hover:bg-slate-50"
                onClick={onClose}
              >
                Close
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Sales_list;
